"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _RadioInputGroup = _interopRequireDefault(require("@insided/shared/uikit/RadioInputGroup"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _Switcher = _interopRequireDefault(require("@insided/deprecated-preact-components/control/Switcher"));

var _index = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/dropdown/index"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DropdownItemWithCheckbox = function DropdownItemWithCheckbox(_ref) {
  var id = _ref.id,
      title = _ref.title,
      _onChange = _ref.onChange,
      value = _ref.value;
  var inputCategoryId = "category-".concat(id);
  return (0, _preact.h)(_index.DropdownItem, {
    key: id
  }, (0, _preact.h)("div", {
    className: "inline"
  }, (0, _preact.h)("label", {
    htmlFor: inputCategoryId
  }, title), (0, _preact.h)("input", {
    checked: value,
    className: "form-control",
    type: "checkbox",
    id: inputCategoryId,
    onChange: function onChange(e) {
      return _onChange(!!e.target.checked);
    }
  })));
};

function getCategoryNamesByIds(ids, categories) {
  return categories.filter(function (v) {
    return ids.includes(v.id);
  }).map(function (t) {
    return t.title;
  }).join(', ');
}

function getSubcategories(parentCategories) {
  if (parentCategories.length > 0) {
    return parentCategories.map(function (c) {
      return c.subforums;
    }).reduce(function (pre, cur) {
      return pre.concat(cur);
    });
  }

  return [];
}
/**
 * Moved from `mega-menu` to here to avoid circular dependency issues.
 */


function isParentCategoryInfo(category) {
  return 'subforums' in category;
}

var CategoryList = function CategoryList(_ref2) {
  var categoryIds = _ref2.categoryIds,
      categories = _ref2.categories,
      _onChange2 = _ref2.onChange;
  return (0, _preact.h)("div", null, categories.map(function (parentCategory) {
    return (0, _preact.h)(_index.DropdownItem, {
      key: parentCategory.id
    }, isParentCategoryInfo(parentCategory) && parentCategory.subforums.length ? (0, _preact.h)("div", {
      className: "with_parent"
    }, parentCategory.title, parentCategory.subforums.map(function (category) {
      return (0, _preact.h)(DropdownItemWithCheckbox, {
        key: category.id,
        id: category.id,
        title: category.title,
        onChange: function onChange(v) {
          return _onChange2(parseInt(category.id), v);
        },
        value: categoryIds.includes(parseInt(category.id))
      });
    })) : (0, _preact.h)(DropdownItemWithCheckbox, {
      key: parentCategory.id,
      id: parentCategory.id,
      title: parentCategory.title,
      onChange: function onChange(v) {
        return _onChange2(parseInt(parentCategory.id), v);
      },
      value: categoryIds.includes(parseInt(parentCategory.id))
    }));
  }));
};

var ManualCategoryOption = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ManualCategoryOption, _Component);

  var _super = _createSuper(ManualCategoryOption);

  function ManualCategoryOption() {
    (0, _classCallCheck2.default)(this, ManualCategoryOption);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ManualCategoryOption, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          categoryIds = _this$props.categoryIds,
          community = _this$props.community,
          knowledgeBase = _this$props.knowledgeBase,
          groups = _this$props.groups;
      var categoryIdsValue = JSON.stringify(categoryIds);
      return (0, _preact.h)("div", null, (0, _preact.h)("input", {
        type: "hidden",
        name: "channel[categoryIds]",
        value: categoryIdsValue
      }), (0, _preact.h)("strong", null, "Manually select the categories which content to display in the conversational widget"), (0, _preact.h)("p", null, "You can only select community categories, knowledge base categories and groups."), (0, _preact.h)("div", null, (0, _preact.h)(_index.default, {
        size: "M",
        popupName: "categories",
        trigger: (0, _preact.h)(_InputGroup.default, {
          title: "Select categories or groups to show",
          error: "",
          readOnly: true,
          value: getCategoryNamesByIds(categoryIds, [].concat((0, _toConsumableArray2.default)(getSubcategories(community)), (0, _toConsumableArray2.default)(getSubcategories(knowledgeBase)), (0, _toConsumableArray2.default)(groups))),
          showIconBeforeErrorMessage: true
        })
      }, community.length > 0 && (0, _preact.h)("div", {
        className: "section"
      }, (0, _preact.h)(_index.DropdownItem, {
        type: "info"
      }, "Community"), (0, _preact.h)(CategoryList, {
        categories: community,
        onChange: this.props.onChange,
        categoryIds: categoryIds
      })), knowledgeBase.length > 0 && (0, _preact.h)("div", {
        className: "section"
      }, (0, _preact.h)(_index.DropdownItem, {
        type: "info"
      }, "Knowledge Base"), (0, _preact.h)(CategoryList, {
        categories: knowledgeBase,
        onChange: this.props.onChange,
        categoryIds: categoryIds
      })), groups.length > 0 && (0, _preact.h)("div", {
        className: "section"
      }, (0, _preact.h)(_index.DropdownItem, {
        type: "info"
      }, "Groups"), (0, _preact.h)(CategoryList, {
        categories: groups,
        onChange: this.props.onChange,
        categoryIds: categoryIds
      })))));
    }
  }]);
  return ManualCategoryOption;
}(_preact.Component);

var SetupWidgetVisibility = /*#__PURE__*/function (_Component2) {
  (0, _inherits2.default)(SetupWidgetVisibility, _Component2);

  var _super2 = _createSuper(SetupWidgetVisibility);

  function SetupWidgetVisibility(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SetupWidgetVisibility);
    _this = _super2.call(this, props);
    var categoryIds = JSON.parse(_this.props.categoryIds); // eslint-disable-next-line react/state-in-constructor

    _this.state = {
      selectedOption: Number(props.showConversationalWidgetValue && Boolean(categoryIds.length)),
      showConversationalWidgetValue: props.showConversationalWidgetValue,
      showInPageWidgetActive: props.showInPageWidgetActive,
      // eslint-disable-next-line react/no-unused-state
      errorMessage: undefined,
      categoryIds: categoryIds
    };
    return _this;
  }

  (0, _createClass2.default)(SetupWidgetVisibility, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var phrases = this.props.phrases;
      var _this$state = this.state,
          showConversationalWidgetValue = _this$state.showConversationalWidgetValue,
          showInPageWidgetActive = _this$state.showInPageWidgetActive,
          selectedOption = _this$state.selectedOption;
      var options = [(0, _preact.h)("div", {
        key: "public"
      }, (0, _preact.h)("strong", null, "Show all publicly available topics"), (0, _preact.h)("p", null, "The conversational widget will show all the topics from categories of the community and knowledge base module which visibility is set to \u201Cunregistered/not logged in\u201D users and above. The conversational widget will also show topics from public groups.")), (0, _preact.h)(ManualCategoryOption, {
        key: "manual",
        community: this.props.communityCategories,
        knowledgeBase: this.props.knowledgeBaseCategories,
        groups: this.props.groups,
        categoryIds: this.state.categoryIds,
        disabled: false,
        onChange: function onChange(v, b) {
          return _this2.setState({
            categoryIds: b ? _this2.state.categoryIds.concat([v]) : _this2.state.categoryIds.filter(function (c) {
              return c !== v;
            })
          });
        }
      })];
      return (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "row display-trigger"
      }, (0, _preact.h)("input", {
        type: "hidden",
        name: "channel[showConversationalWidget]",
        value: Number(showConversationalWidgetValue)
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "col-sm-12",
        on: showConversationalWidgetValue,
        onChange: function onChange() {
          return _this2.setState({
            showConversationalWidgetValue: !showConversationalWidgetValue
          });
        },
        label: phrases.showConversationalWidget
      })), showConversationalWidgetValue && (0, _preact.h)("div", {
        className: "row display-trigger"
      }, (0, _preact.h)("div", {
        className: "col-sm-12"
      }, (0, _preact.h)(_RadioInputGroup.default, {
        title: "",
        options: options,
        onChange: function onChange(_, idx) {
          return _this2.setState({
            selectedOption: idx,
            categoryIds: idx === 0 ? [] : _this2.state.categoryIds
          });
        },
        value: options[selectedOption],
        isFlexView: true
      }))), (0, _preact.h)("div", {
        className: "row display-trigger"
      }, (0, _preact.h)("input", {
        type: "hidden",
        name: "channel[showInPageWidget]",
        value: Number(showInPageWidgetActive)
      }), (0, _preact.h)(_Switcher.default, {
        customClass: "col-sm-12",
        on: showInPageWidgetActive,
        onChange: function onChange() {
          return _this2.setState({
            showInPageWidgetActive: !showInPageWidgetActive
          });
        },
        label: phrases.showInPageWidget
      })));
    }
  }]);
  return SetupWidgetVisibility;
}(_preact.Component);

exports.default = SetupWidgetVisibility;